import { useEffect, useState } from 'react';
import { useDebounce } from '@beeline.com/bp-design-system';
import { breakpoints } from 'src/utils/BreakPoints';

export const useScreenSizes = (isBelowCustomBreakpoint?: number) => {
  const size = useWindowSize();

  // below 600
  const isSmallMobileScreen = size.width < breakpoints.sm;
  // between 600 and 904
  const isOnlyMobileScreen = size.width >= breakpoints.sm && size.width < breakpoints.md;
  // 905 or less
  const isAnyMobileScreen = size.width <= breakpoints.md;
  // between 906 and 1239
  const isTabletScreen = size.width >= breakpoints.md && size.width < breakpoints.lg;
  // between 1280 and 1439
  const isLarge = size.width >= breakpoints.lg && size.width < breakpoints.xl;
  // 1440 or more
  const isExtraLarge = size.width >= breakpoints.xl;
  const isBelowCustomSize = size.width < (isBelowCustomBreakpoint ?? 0);

  return {
    currentSize: size,
    isBelowCustomSize,
    isTabletScreen,
    isOnlyMobileScreen,
    isLarge,
    isSmallMobileScreen,
    isExtraLarge,
    isAnyMobileScreen
  };
};

const getSize = () => ({ width: window.innerWidth, height: window.innerHeight });
function useWindowSize() {
  const [windowSize, setWindowSize] = useState(getSize);

  const debouncedSetWindowSize = useDebounce(setWindowSize, 66);
  // biome-ignore lint/correctness/useExhaustiveDependencies: exception
  useEffect(() => {
    function handleResize() {
      debouncedSetWindowSize(getSize());
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize, false);
  }, []);

  return windowSize;
}
